import React, {useCallback, useState} from 'react';
import axios from 'axios'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import {MessageChip} from 'component/MessageChip';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles(theme => ({
	form: {
		minHeight: 220,
		width: '100%',
	},
	textField: {},
	container: {
		width: '100%',
		paddingTop: theme.spacing(2),
		textAlign: 'center',
	},
}));

function getVisibilityIcon(visible) {
	return Boolean(visible) ? <Visibility color={'action'}/> : <VisibilityOff color={'action'}/>
}

export const ChangePasswordComponent = () => {
	const [pwOld, setPwOld] = useState('');
	const [pw1, setPw1] = useState('');
	const [pw2, setPw2] = useState('');
	const [msg, setMsg] = useState(null);
	const [pswVisibility, setPswVisibility] = useState({old: false, pw1: false, pw2: false});
	const handlePswVisibility = (pw) => {
		let p = pswVisibility[pw];
		setPswVisibility(
			{
				...pswVisibility,
				[pw]: !p,
			},
		)
	};

	const clearMsg = useCallback(() => setMsg(null), []);

	const changePasswordHandler = useCallback(() => {
		const requestData = {
			current_password: pwOld,
			new_password: pw1,
			new_password_confirm: pw2,
		};
		axios.post("../json/evoAppsUserInfoDialogController/change-default-user-password", requestData)
			.then(() => {
				setPwOld('');
				setPw1('');
				setPw2('');
				setMsg({status: 'ok', text: "Passwort wurde geändert."});
			}).catch(({response}) => {
			const text = response && response.data && response.data.message;
			setMsg({status: 'error', text: text || "Ein unerwarteter Fehler ist aufgetreten."});
		});
	}, [pw1, pw2, pwOld]);

	const classes = useStyles();

	return (
		<form noValidate autoComplete="off" className={classes.form}>
			<TextField
				value={pwOld}
				onChange={useCallback((evt) => setPwOld(evt.target.value), [])}
				type={pswVisibility['old'] ? 'text' : 'password'}
				className={classes.textField}
				margin={'dense'}
				fullWidth
				label={'Aktuelles Passwort'}
				InputProps={{
					endAdornment: (
						<InputAdornment position="start" onClick={() => handlePswVisibility('old')}>
							{getVisibilityIcon(pswVisibility['old'])}
						</InputAdornment>
					),
				}}
			/>
			<TextField
				value={pw1}
				onChange={useCallback((evt) => setPw1(evt.target.value), [])}
				type={pswVisibility['pw1'] ? 'text' : 'password'}
				className={classes.textField}
				margin={'dense'}
				fullWidth
				label={'Neues Passwort'}
				InputProps={{
					endAdornment: (
						<InputAdornment position="start" onClick={() => handlePswVisibility('pw1')}>
							{getVisibilityIcon(pswVisibility['pw1'])}
						</InputAdornment>
					),
				}}
			/>
			<TextField
				value={pw2}
				onChange={useCallback((evt) => setPw2(evt.target.value), [])}
				type={pswVisibility['pw2'] ? 'text' : 'password'}
				className={classes.textField}
				margin={'dense'}
				fullWidth
				label={'Neues Passwort bestätigen'}
				InputProps={{
					endAdornment: (
						<InputAdornment position="start" onClick={() => handlePswVisibility('pw2')}>
							{getVisibilityIcon(pswVisibility['pw2'])}
						</InputAdornment>
					),
				}}
			/>

			<Container className={classes.container}>
				<Button onClick={changePasswordHandler}>Passwort ändern</Button>
			</Container>
			{msg &&
			<Container className={classes.container}>
				<MessageChip variant={'warn'} label={msg.text} onClick={clearMsg}/>
			</Container>
			}
		</form>
	);
};